import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBaseHistory } from 'spindl-shared-components';

import { userTemplateColumns } from '../../../lib/constants';
import { getTranslation } from '../../../lib/reactUtils';
import { convertToCSVColumns, downloadFile } from '../../../lib/utils';
import { DownloadCSVCombinedProps } from './types';

const usePresenter = (props: DownloadCSVCombinedProps): DownloadCSVCombinedProps => {
  const { isCSVTemplateDownloaded, setIsCSVTemplateDownloaded } = props;
  const { t } = useTranslation();
  const history = useBaseHistory();

  const [templateDownloaded, setTemplateDownloaded] = useState<boolean>(false);

  const goToUploadCSV = () => {
    if (setIsCSVTemplateDownloaded) {
      setIsCSVTemplateDownloaded(true);
    }
    history.replace('/wizard/uploadCSV');
  };

  const handleCloseWizard = () => {
    history.replace('/');
  };

  const handleBackButton = () => {
    history.replace('/wizard');
  };

  const handleDownloadCSVTemplate = () => {
    // TODO: Assign hardcoded value for now until we decided how to store column info
    const columns = userTemplateColumns.concat();
    downloadFile(convertToCSVColumns(columns), t('default.user_template_file_name'), 'text/csv;charset=utf-8;');
    setTemplateDownloaded(true);
  };

  return {
    ...props,
    stepLabelList: {
      stepLabels: [
        {
          state: 'Completed',
          styleType: 'Default',
          stepNumber: {
            text: {
              value: '1',
            },
          },
          text: {
            value: t('step_labels.select_method'),
          },
        },
        {
          stepNumber: {
            text: {
              value: '2',
            },
          },
          text: {
            value: t('step_labels.download_template'),
          },
        },
        {
          state: 'Disabled',
          styleType: 'End',
          stepNumber: {
            text: {
              value: '3',
            },
          },
          text: {
            value: t('step_labels.invite_users'),
          },
        },
      ],
    },
    button: {
      onClick: handleCloseWizard,
    },
    label: {
      value: t('downloadCSV.title'),
    },
    instructions: {
      value: getTranslation('downloadCSV.instruction'),
    },
    text: {
      value: getTranslation('downloadCSV.text'),
    },
    chip: {
      text: {
        value: t('default.role'),
      },
    },
    fileAction: {
      type: templateDownloaded ? 'Subdued' : 'Primary',
      text: {
        value: t('default.user_template_file_name'),
      },
      button: templateDownloaded ? {
        type: 'Text',
        size: 'M',
        styleType: 'Primary',
        state: 'Loaded',
        icon: {
          asset: 'SelectedFilled',
        },
        text: {
          value:  t('button.downloaded'),
        },
        onClick: handleDownloadCSVTemplate,
      } : {
        size: 'M',
        text: {
          value: t('button.download'),
        },
        onClick: handleDownloadCSVTemplate,
      },
    },
    button1: {
      text: {
        value: t('downloadCSV.skip_this_step'),
      },
      onClick: goToUploadCSV,
    },
    backButton: {
      text: {
        value: t('button.back'),
      },
      onClick: handleBackButton,
    },
    continueButton: {
      text: {
        value: t('button.continue'),
      },
      disabled: isCSVTemplateDownloaded ? false : !templateDownloaded,
      onClick: goToUploadCSV,
    },
  };
};

export default usePresenter;
